import React from 'react';
import { ModellingIcon } from '@virtus/components/icons';
import styled from 'styled-components';

export const IconButton = styled.button<{ useDarkTheme: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 18px;
  width: 18px;
  line-height: 18px;
  background: transparent;
  border: none;

  & svg {
    fill: ${props => (props.useDarkTheme ? 'white' : 'black')};
  }

  &.icon-active svg {
    fill: var(--accent);
  }

  &:disabled svg {
    opacity: 0.6;
  }
`;

export interface ModalActionButton {
  text: string;
  action: (e: any) => void;
  disabled?: boolean;
}
export interface ModellingProps {
  onIconClick: () => void;
  useDarkTheme: boolean;
  isDisabledIcon?: boolean;
  isActiveIcon?: boolean;
}

const Modelling: React.FunctionComponent<ModellingProps> = ({
  onIconClick,
  useDarkTheme,
  isDisabledIcon = false,
  isActiveIcon = false,
}) => {
  const onModellingClick = () => {
    if (isDisabledIcon) return;
    if (onIconClick) {
      onIconClick();
    }
  };

  return (
    <IconButton useDarkTheme={useDarkTheme} className={isActiveIcon ? 'icon-active' : ''} disabled={isDisabledIcon}>
      <ModellingIcon onClick={onModellingClick} />
    </IconButton>
  );
};

export default Modelling;
